import goals from "../../../../src/components/content/goals/m2";
import * as React from 'react';
export default {
  goals,
  React
};